<template>
  <div class="hundred_percent_form left_form">
    <el-form :label-position="labelPosition" v-loading="loading" ref="form" :model="form" label-width="100px">
      <el-form-item label="Logo">
          <el-upload
              v-show="pic_is_show"
              class="avatar-uploader"
              style="margin-bottom: 15px;"
              accept=".png, .jpg, .gif, .jpeg, .bmp"
              :action="uploadUrl"
              :headers="{'hfmauth':'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
          >
              <img v-if="form.configsurl" :src="form.configsurl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
      </el-form-item>
      <el-form-item label="名称">
        <el-input style="width: 200px;"  v-model="form.configsname" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="formSubmit" :loading="formLoading">保 存</el-button>
        <el-button @click="onCancel">取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { aboutUs, editaboutUs } from "../../api/setting/text.js";
import {BASE_URL} from "../../config/app";
export default {
    data() {
        return {
            loading: true,
            formLoading: false,
            divLoading: false,
            form: {
                configsid:"",
                configsurl: "",
                configsname: "",
                configstype: 0
            },
            labelPosition: "left",
            uploadUrl: BASE_URL + "/upload/tool/uploadpro",
            pic_is_show: true,
        };
    },
    components: {
        /*Upload,
        Tinymce*/
    },
    methods: {
        onCancel() {
            this.getInfo();
        },
        onSelectPic(filePath) {
            this.divLoading = true;
            this.form.configsurl = filePath;
            setTimeout(() => {
                this.divLoading = false;
            }, 0.8 * 1000);
        },
        getInfo() {
            this.loading = true;
            aboutUs({ configstype: this.form.configstype })
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    if (response.data) {
                        this.form = response.data;
                    }
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {});
        },
        formSubmit() {
            this.formLoading = true;
            let data = Object.assign({}, this.form);
            console.log(data);
            editaboutUs(data).then(response => {
                this.formLoading = false;
                if (response.code) {
                    this.$message.error(response.message);
                    return false;
                }
                this.$message.success("操作成功");
                //刷新表单
                this.getInfo();
            });
        },
        handleAvatarSuccess(res, file) {
            this.form.configsurl = res.data;
            console.info(res);
            console.info(file);
        },
    },
    created() {
        // 加载版本数据
        this.getInfo();
    }
};
</script>

<style type="text/scss" lang="scss">
body {
    margin: 0;
}
.app_logo {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.loading_div {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
